import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const sizes = {
	sm: 'max-w-md',
	md: 'max-w-lg',
	lg: 'max-w-2xl',
	xl: 'max-w-4xl'
};

export default function Modal({ isOpen, onClose, title, children, size = 'md' }) {
	useEffect(() => {
		function onEsc(e) {
			if (e.key === 'Escape') onClose?.();
		}
		if (isOpen) {
			document.addEventListener('keydown', onEsc);
		}
		return () => document.removeEventListener('keydown', onEsc);
	}, [isOpen, onClose]);

	if (!isOpen) return null;
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className={`relative w-full ${sizes[size]} mx-4 bg-white rounded-lg shadow-lg`}>
				<div className="flex items-center justify-between px-4 py-3 border-b">
					<h3 className="text-lg font-semibold">{title}</h3>
					<button onClick={onClose} aria-label="Close">
						<X className="w-5 h-5" />
					</button>
				</div>
				<div className="p-4">{children}</div>
			</div>
		</div>
	);
}


